import React from 'react';
import { Stepper, Step, StepLabel, Box } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../modules/constants/colors';

const StepperContainer = styled(Box)`
  margin-bottom: 40px;

  .MuiStepLabel-root .Mui-completed {
    color: ${colors.primary};
  }

  .MuiStepLabel-root .Mui-active {
    color: ${colors.primary};
  }

  .MuiStepConnector-alternativeLabel {
    top: 10px;
    left: calc(-50% + 16px);
    right: calc(50% + 16px);
  }

  .MuiStepConnector-alternativeLabel.Mui-active .MuiStepConnector-line,
  .MuiStepConnector-alternativeLabel.Mui-completed .MuiStepConnector-line {
    border-color: ${colors.primary};
  }

  .MuiStepLabel-label {
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
  }
`;

const RegisterStepper = ({ activeStep, steps }) => {
  return (
    <StepperContainer>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </StepperContainer>
  );
};

export default RegisterStepper;
